// CSS import order matters:
// 1. Tailwind + scanned sources (./tailwind.css) + token bridge from @vantage-hub/ui
// 2. Brand theme overrides (this brand's actual token values)
import './tailwind.css'
import './theme.css'

import { bootstrap } from '@vantage-hub/app-core-certificate-portal'
import { brinksConfig } from './brand.config.js'

bootstrap(brinksConfig)
